import React from 'react';
import { faTimes, faSave, faTimesCircle, faBoxOpen, faPersonChalkboard, faChartLine, faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { FloatingActionButtonBar } from '../../../../components/area-layout/floating-action-button-bar';
import { FloatingActionButton } from '../../../../components/area-layout/floating-action-button';
import { FabDivider } from '../../../../components/area-layout/fab-divider';

interface ICourseLaunchboxProps {
  onSave: () => void;
  onValidate: () => boolean;
  isLoading: boolean;
  isCompleted: boolean;
  onFinishCourse: () => void;
  onAddLesson: () => void;
  onOpenStatistics?: () => void;
  onDelete: () => void;
  isDeleting: boolean;
  cannotBeDeletedReason?: string;
  hasAttendanceWrite: boolean;
}

export function CourseLaunchbox(props: ICourseLaunchboxProps) {
  const { isLoading, onSave, onValidate, isCompleted, onFinishCourse, onAddLesson, onOpenStatistics, onDelete, isDeleting, cannotBeDeletedReason, hasAttendanceWrite } = props;

  function handleSave() {
    if (onValidate()) {
      onSave();
    }
  }

  return (
    <FloatingActionButtonBar>
      {hasAttendanceWrite && (
        <>
          <FloatingActionButton buttonText={!isCompleted ? 'Afslut hold' : 'Aktivér hold'} icon={!isCompleted ? faTimesCircle : faBoxOpen} onClick={onFinishCourse} />
          {!isCompleted && <FloatingActionButton buttonText="Opret lektion" icon={faPersonChalkboard} onClick={onAddLesson} />}
          {onOpenStatistics && (
            <FloatingActionButton
              buttonText={
                <span>
                  Fremmøde <br />
                  statistik
                </span>
              }
              icon={faChartLine}
              onClick={onOpenStatistics}
            />
          )}
          <FloatingActionButton
            buttonText="Slet hold"
            icon={faTrashCan}
            onClick={onDelete}
            loading={isDeleting}
            disabled={!!cannotBeDeletedReason}
            disabledTooltipText={cannotBeDeletedReason}
          />
          <FabDivider />
          <FloatingActionButton buttonText="Gem og luk" icon={faSave} onClick={handleSave} loading={isLoading} inverted />
        </>
      )}
      <FloatingActionButton buttonText="Luk" icon={faTimes} onClick={() => window.close()} inverted />
    </FloatingActionButtonBar>
  );
}
